import TimeTrackingView from './TimeTrackingView';

export default TimeTrackingView;
